import { useState} from 'react'
import {Header,AlertText,ContainerVertical,Link,InputBox,InputLabel,SubmitButton} from '../styles/style.js'
import {IntroductionBackground} from '../styles/form.js'
import {API} from 'aws-amplify'
import DatePicker from './DatePicker.jsx'
import PDF from './BHTI_Notice_of_Privacy_Practices.pdf'
import {useDispatch} from 'react-redux'
import { setExamPassword} from '../redux/ExamSlice.js';
import WriteDB from '../API/WriteDB.js'

const writeDB = new WriteDB();
export default function Introduction(props){
    const [password,setPassword] = useState('');
    const [error,setError] = useState(false);
    const [errorText,setErrorText] = useState('');
    const [patientDOB,setPatientDOB] = useState('');
    const [submitText,setSubmitText] = useState('Start');
    const dispatch = useDispatch();
   
    const handleSubmit = async(event) =>{
        event.preventDefault();
        setSubmitText('Submitting')
        if(props.type === 'Initial' && patientDOB === ''){
            setError(true)
            setErrorText('Please enter your date of birth')
            setSubmitText('Start')
        }else{
            if(props.type === 'Initial'){
                var response = writeDB.writePatientDOB(patientDOB)
                if(response === 'Incorrect Password'){
                    setError(true)
                    setErrorText('Incorrect Password')
                    setSubmitText('Start')
                }
            }

            var queryString = '/read?link=' + window.location.pathname + '&password=' + 
                password + '&type=password';

            await API.get('Patient',queryString).then(response =>{
                if(response === true){
                    dispatch(setExamPassword(password))
                    props.message({'Introduction':'done'});
                }else{
                    setError(true)
                    setErrorText('Incorrect Password')
                    setSubmitText('Start')
                }
            });
        }
    }

    const handleDateDone = date =>{
        setPatientDOB(date)
    }

    return (
        <IntroductionBackground>
            <ContainerVertical>
                {props.showIntroduction &&
                    <>
                        {props.type === 'Initial' && 
                            <>
                                <Header>
                                    This screening tool is used to evaluate the following 
                                    possible disorders and conditions: depression, anxiety, 
                                    post-traumatic stress disorder, autism spectrum disorder, 
                                    borderline personality disorder, mood disorders, substance 
                                    use disorders, and attention deficit hyperactivity disorder.
                                </Header>

                                <Header>Average time to complete: 15-20 minutes</Header>
                            </>
                        }

                        {props.type === 'Checkup' && 
                           <>
                                <Header>
                                    This screening tool is used to reassess the following 
                                    possible disorders and conditions: depression, anxiety, 
                                    and overall well-being.
                                </Header>

                                <Header>Average time to complete: 2-5 minutes</Header>
                           </>
                        }

                        {(props.type === 'Six-Month' || props.type === 'Full Exam' || props.type === 'Three-Month') && 
                           <>
                                <Header>
                                    This screening tool is used to reevaluate the following 
                                    possible disorders and conditions: depression, anxiety, 
                                    post-traumatic stress disorder, autism spectrum disorder, 
                                    borderline personality disorder, mood disorders, 
                                    substance use disorders, and attention deficit hyperactivity disorder.
                                </Header>

                                <Header>Average time to complete: 15-20 minutes</Header>
                           </>
                        }

                        {props.type === 'Select Forms' && 
                            <>
                                <Header>
                                    This screening tool is used to reevaluate the following 
                                    possible disorders and conditions: depression, anxiety, 
                                    post-traumatic stress disorder, autism spectrum disorder, 
                                    borderline personality disorder, mood disorders, 
                                    substance use disorders, and attention deficit hyperactivity disorder.
                                </Header>

                                <Header>
                                    Average time to complete: Variable(Depends on the 
                                    number and types of forms the clinician assigned)
                                </Header>
                            </>
                        }

                        {error &&
                            <AlertText>{errorText}</AlertText>
                        }

                        {props.type === 'Initial' &&
                           <>
                               <InputLabel htmlFor='patientDOB'>Date of Birth</InputLabel>
                               <DatePicker onDateDone={handleDateDone}></DatePicker>
                           </>
                        }

                        <InputBox
                            placeholder='Password' 
                            type='text' 
                            name='password' 
                            value={password} 
                            onChange={e =>{setPassword(e.target.value)}} 
                            maxLength='6'>
                        </InputBox>
                        <SubmitButton onClick={handleSubmit}>
                            {submitText}
                        </SubmitButton>
                    </>
                }

                {!props.showIntroduction &&
                    <>
                        <Header>
                            Please request a link from your healthcare provider.
                        </Header>
                    </>
                }
                <Link href={PDF} target="_blank">HIPAA Notice</Link>
            </ContainerVertical>
        </IntroductionBackground>
    )
}
